import React, { Component } from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import PaperBox from '../../atoms/PaperBox'
import FormElementsGroup from '../FormElementsGroup'

class Form extends Component {
  _fieldsRef

  render() {
    const {
      classes,
      name,
      title,
      buttonLabel,
      buttonName,
      isSubmitting,
      elements,
      externalErrors,
      extra,
      buttonStyles,
    } = this.props

    return (
      <form
        noValidate
        className={classes.root}
        name={name}
        data-testid={this.props['data-testid'] || 'form'}
      >
        <PaperBox
          title={title}
          pending={isSubmitting}
          buttonLabel={buttonLabel}
          buttonName={buttonName}
          onButtonClick={this._handleButtonClick}
          moreComponents={extra}
          classes={{ headline: classes.headline }}
          buttonStyles={buttonStyles}
          data-testid={`${this.props['data-testid'] || 'form'}-paper-box`}
        >
          <FormElementsGroup
            externalErrors={externalErrors}
            elements={elements}
            data-testid={`${this.props['data-testid'] || 'form'}-elements-group`}
            innerRef={ref => {
              this._fieldsRef = ref
            }}
          />
        </PaperBox>
      </form>
    )
  }

  _handleButtonClick = e => {
    e.preventDefault()

    if (!this._fieldsRef || !this._fieldsRef.checkValidity()) {
      return
    }

    const { onSubmitClick } = this.props
    onSubmitClick && onSubmitClick(this._fieldsRef.getValues())
  }
}

const styles = () => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  headline: {
    textTransform: 'inherit',
    textAlign: 'center',
  },
})

export default withStyles(styles)(Form)
